import { createClient } from "@supabase/supabase-js";

export const useSupabaseClient = () => {
    return createClient(import.meta.env.VITE_SUPABASE_URL_PROD, import.meta.env.VITE_SUPABASE_ANON_KEY_PROD)
};